export default __webpack_public_path__ + "static/media/mobile.23fe5a72.svg";